import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SptRecorderService} from '@spout/global-web/data-access';

@Component({
  selector: 'spt-help-sample-rate-content',
  templateUrl: './help-sample-rate-content.component.html',
  styleUrls: ['./help-sample-rate-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpSampleRateContentComponent {
  constructor(private _recorder: SptRecorderService) {}
  refresh(): void {
    this._recorder.refreshAudioDeviceList().subscribe(() => {});
  }
}
